export default "__VITE_ASSET__Dn732gl6__"